import styled from "styled-components";
import { SideResponse } from "../../../codegen-api";
import { COLORS, TEXT_COLORS } from "../../../constants/design/colors";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { Button } from "../../Buttons/styles";

// `onClick` is deliberately NOT declared here. It is a real React handler that
// styled-components already types from HTMLAttributes and that must keep
// reaching the DOM — so it is the one prop in this file that must never become
// `$onClick`. Declaring it in the generic added nothing and made it look like a
// custom prop leaking to the DOM.
export const Align = styled.div<{
  align?: "left" | "right" | "center";
}>`
  text-align: ${({ align }) => align || "left"};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ align }) => {
    switch (align) {
      case "left":
        return "flex-start";
      case "center":
        return "center";
      case "right":
        return "flex-end";
      default:
        return "center";
    }
  }};
`;

export const Direction = styled.div<{ side: SideResponse }>`
  color: ${({ side }) =>
    side === SideResponse.Buy ? COLORS.up.one : COLORS.down.one};
`;

export const GroupedCells = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  > ${Button} {
    width: 100%;
    max-height: 32px;
    min-height: 32px;
    border-radius: 8px;
  }
`;

export const SizeFillCell = styled.div`
  ${FONT_CSS.data.three}
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: ${TEXT_COLORS.one};
  span:last-child {
    ${FONT_CSS.data.four}
    color: ${TEXT_COLORS.three};
  }
`;

export const TPSLContainer = styled.div`
  display: flex;
`;

export const TPSLCell = styled.div`
  ${FONT_CSS.data.three}
  display: flex;
  flex-direction: column;
  color: ${TEXT_COLORS.two};
`;
